import React from 'react';

const IntegrationError = ({ error, state }) =>
  state === 'error' && error && <div className="text-danger">{error}</div>;

export default IntegrationError;
